module.exports = require("./lib/_stream_duplex.js")



/*****************
 ** WEBPACK FOOTER
 ** ./~/node-libs-browser/~/readable-stream/duplex.js
 ** module id = 360
 ** module chunks = 0
 **/